var _path, _circle, _circle2, _rect, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0991 2C11.7326 2 11.4026 2.2219 11.2643 2.56131L9.65676 6.50704H3.60563C1.6143 6.50704 0 8.12134 0 10.1127V25.4366C0 27.428 1.6143 29.0423 3.60563 29.0423H28.3944C30.3857 29.0423 32 27.428 32 25.4366V10.1127C32 8.12134 30.3857 6.50704 28.3944 6.50704H22.3432L20.7357 2.56131C20.5974 2.2219 20.2674 2 19.9009 2H12.0991Z",
    fill: "#FFC23D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 18,
    r: 8,
    fill: "#C7A04C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.0024,
    cy: 17.9994,
    r: 5.71429,
    fill: "#CCE5FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.6846,
    y: 9.66016,
    width: 4.26559,
    height: 2.70423,
    rx: 1.35211,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.0941,
    cy: 17.5501,
    r: 1.57746,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.741,
    cy: 14.8455,
    r: 1.12676,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/Camera_Icon.4f66624ef6401fc8c71a0d0ab433c14a.svg";
export { ForwardRef as ReactComponent };